export const VA_SELECTED_PROJECT = "";
export const ITEMS_PER_PAGE = 15;
export const FIREBASE_ID_TOKEN = "";
